export * from './iconFontAwesomeFruitsVegetablesLemon';
export * from './iconFontAwesomeFruitsVegetablesLeaf';
export * from './iconFontAwesomeFruitsVegetablesSeedling';
export * from './iconFontAwesomeFruitsVegetablesPepperHot';
export * from './iconFontAwesomeFruitsVegetablesCarrot';
export * from './iconFontAwesomeFruitsVegetablesAppleWhole';
